import React from 'react';
import CheckboxList, { FilterListItem } from '../CheckboxList';
import { useAuth } from '../../../context/Auth';
import { TriggerType } from '../../../schemas/dispatch';
import { translate } from '../../../services/translate';
import { FieldValues, Path } from 'react-hook-form';

function TriggerTypeList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const { user } = useAuth();
    const types: { permission: string; type: TriggerType | 'manual'; }[] = [
        { permission: 'events_manage_wanted_face_occurrence', type: 'face_detected' },
        { permission: 'events_manage_missing_face_occurrence', type: 'missing_face_detected' },
        { permission: 'events_manage_wanted_plate_occurrence', type: 'plate_detected' },
        { permission: 'events_manage_wanted_plate_by_mobile_agent_occurrence', type: 'plate_detected_by_mobile_agent' },
        { permission: 'events_manage_wanted_plate_by_citizen_app_occurrence', type: 'plate_detected_by_citizen_app' },
        { permission: 'events_manage_irregular_vehicle_occurrence', type: 'irregular_vehicle' },
        { permission: 'events_manage_clone_suspect_occurrence', type: 'clone_suspect' },
        { permission: 'events_manage_illegal_debris_occurrence', type: 'illegal_debris' },
        { permission: 'events_manage_area_invasion_occurrence', type: 'area_invasion' },
        { permission: 'events_manage_people_crowd_occurrence', type: 'people_crowd' },
        { permission: 'events_manage_mp_wanted_plate_occurrence', type: 'mp_plate_detected' },
        { permission: 'events_manage_mp_wanted_mobile_agent_plate_occurrence', type: 'mp_mobile_agent_plate_detected' },
        { permission: 'events_manage_mp_wanted_face_occurrence', type: 'mp_face_detected' },
        { permission: 'events_manage_alarm_center_occurrence', type: 'alarm_center' },
        { permission: 'events_manage_manual_occurrence', type: 'manual' },
        { permission: 'events_manage_guardian_app_occurrence', type: 'guardian_app' },
        { permission: 'events_manage_school_app_occurrence', type: 'school_app' },
        { permission: 'events_manage_sigrc_occurrence', type: 'sigrc' },
        { permission: 'events_manage_cortex_plate_occurrence', type: 'cortex_plate_detected' },
        { permission: 'events_manage_camera_depredation_occurrence', type: 'scenechangedetection' },
    ];

    const items: FilterListItem[] = types
        .filter(({ permission }) => user?.isAdmin || user?.permissions.events_module_access || user?.permissions[permission as keyof typeof user.permissions])
        .map(({ type }) => ({ label: translate(type), value: type }));

    return <CheckboxList name={name} items={items} showSelectedItems={true} />;
}

TriggerTypeList.getCount = CheckboxList.getCount;

export default TriggerTypeList;
